var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"flex item-center justify-center border-slate-200 border-t backdrop-blur-md bg-white/25"},[_c('div',{staticClass:"text-darkblue py-2.5 font-semibold"},[_vm._v(" Copyright © 2023 created by yuz ")])])])
}]

export { render, staticRenderFns }